module.exports = __webpack_public_path__ + "img/3c.cf9ac90d.svg";